import { useMemo } from 'react';

const colorMap: Record<string, string> = {
  svart: '#161616',
  vit: '#fff',
  grön: '#45b83a',
  gul: '#f4ce15',
  grå: '#c9c9c9',
  rosa: '#efb9f9',
  brun: '#a57a2f',
  blå: '#6d96d3',
  orange: '#fea63d',
  röd: '#d14848',
  lila: '#bc44ef',
  beige: '#d2cca5',
  turkos: '#55c5c6',
};

export const useColors = (colorScale?: string[]) =>
  useMemo(
    () =>
      colorScale
        ?.filter((c) => !!c)
        .map((name) => ({
          name,
          hex: colorMap[name.toLocaleLowerCase()] || '#fff',
        })) || [],
    [colorScale],
  );
